export default __webpack_public_path__ + "static/media/mysteryBet.8c15f604.png";